<template>
  <div class="qualitycheckvalue-formpanel">
      <v-card class="mx-auto">
        <v-form>
        <v-list-item>
          <v-list-item-content>
            <div class="overline mb-4">
              {{$t('qualitycheck.qualitycheck.qualitycheckvalue')}}
            </div>
            <v-textarea
              v-model="item.comment"
              :error-messages="commentErrors"
              :label="$t('qualitycheck.qualitycheck.comment')"
              @input="$v.item.comment.$touch()"
              @blur="$v.item.comment.$touch()"
            />
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="valueSelectItems"
            color="green"
            class="mr-sm-2"
            @click="validate(true)"
          >
            {{ $t('global.validate') }}
          </v-btn>
          <v-btn
            v-if="valueSelectItems"
            color="error"
            class="mr-sm-2"
            @click="validate(false)"
          >
            {{ $t('global.invalidate') }}
          </v-btn>
        </v-card-actions>
        </v-form>
    </v-card>
  </div>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import NotificationMixin from '../../mixins/NotificationMixin';
import { required } from 'vuelidate/lib/validators';
export default {

  name: 'QualityCheckValuePanelForm',
  mixins: [validationMixin,NotificationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    nextStep: {
      type: Function,
      required: false
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.valueGetSelectItems();
      this.item.comment = this.values.comment;
      this.item.value = this.values.value;
      this.item.['@id'] = this.values.['@id'];
  },
  data() {
    return {
      item: {
        comment: null,
        value: null,
      },
      validateAction : true,
    };
  },

  computed: {
      ...mapFields('qualitycheckvaluetype', {
        valueSelectItems: 'selectItems'
      }),
      ...mapFields('qualitycheckvalue', {
        deleteLoading: 'isLoading',
        isLoading: 'isLoading',
        error: 'error',
        updated: 'updated',
        violations: 'violations'
      }),
      ...mapGetters('qualitycheckvalue', ['find']),
    // eslint-disable-next-line
/*
    item() {
        return this.initialValues || this.values;
    },*/
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);

      !this.$v.item.comment.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    violations() {
      return this.errors || {};
    },
  },
  methods: {
      ...mapActions({
        valueGetSelectItems: 'qualitycheckvaluetype/fetchSelectItems'
      }),
      ...mapActions('qualitycheckvalue', {
        update: 'update',
      }),
      validate(value) {
        if (value) {
          this.validateAction = true;
        } else {
          this.validateAction = false;
        }
        this.$v.$touch();
        if (!this.$v.$invalid) {
          var entityvalue = this.getEntityValue(value);
          if(entityvalue) {
            this.$v.item.$model.value = entityvalue;
            this.$v.item.value = entityvalue;
            this.update(this.$v.item.$model);
          }
          this.nextStep(this.values['qualityCheckTest'].number);
        } else {
          console.log('error');
        }

      },
      getEntityValue(value) {
        for (var i = 0; i < this.valueSelectItems.length; i++) {
          if (value && this.valueSelectItems[i].successValue) {
            return this.valueSelectItems[i]['@id'];
          } else if (! value && !this.valueSelectItems[i].successValue && !this.valueSelectItems[i].originvalue)  {
            return this.valueSelectItems[i]['@id'];
          }
        }
        return null;
      },
  },
  watch: {

    updated(val) {
      if (val['name']) {
        this.showMessage(`${val['name']} ${this.$t('global.updated')}`);
      } else {
        this.showMessage(`${val['@id']} ${this.$t('global.updated')}`);
      }
    },

  },
/*
  validations: {
    item: {
      comment: {
        required
      },
    }
  }*/

  validations() {

      if (this.validateAction) {
        return {
          item: {
            comment: {

            },
          }
        }
      } else {
        return {
          item: {
            comment: {
              required
            },
          }
        }
      }
  }

};
</script>
